<template>
  <div class="landing-component">
    <div class="header">
      <button class="back">
        <h3><a href="https://lightbox.terna.it">{{content.back}}</a></h3>
      </button>
      <h3 :class="['lang-switch',{'it' : lang === 'it'}, {'en': lang === 'en'}]">
        <a class="it" :href="langLinks.it">ITA</a>/
        <a class="en" :href="langLinks.en">ENG</a>
      </h3>
      <div class="social-share" @click="showSocial = !showSocial">
        <svgicon class="share-icon" icon="Share" width="18" height="18"></svgicon>
        <social-sharing
          v-if="showSocial"
          class="social-icons"
          :url="content.share.url"
          :title="content.share.title"
          :description="content.share.description"
          :quote="content.share.description"
          inline-template
        >
          <div>
            <network network="facebook">
              <svgicon icon="fb" width="25" height="25"></svgicon>
            </network>
            <network network="linkedin">
              <svgicon icon="linkin" width="25" height="25"></svgicon>
            </network>
            <network network="twitter">
              <svgicon icon="tw" width="25" height="25"></svgicon>
            </network>
          </div>
        </social-sharing>
      </div>
    </div>
    <div
      :class="['landing-image', {'active' : active}]"
      :style="{ backgroundImage: 'url(' + baseUrl + 'images/'+content.image + (device === 'mobile' ? '_mobile' : '_desktop')+ ($retina && device !== 'mobile'  ? '_2x' : '') +'.jpg)' }"
    ></div>
    <div class="title">
      <h1 v-html="content.title">{{content.title}}</h1>
    </div>
  </div>
</template>
<script>
import "@/compiled-icons/fb";
import "@/compiled-icons/tw";
import "@/compiled-icons/Share";
import "@/compiled-icons/linkin";

export default {
  props: ["content", "active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showSocial: false,
      device: "",
      lang: '',
      langLinks: null
    };
  },
  created() {
    this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    window.addEventListener("resize", () => {
      this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    });
    if(process.env.VUE_APP_LANG === 'IT'){
        return this.lang = 'it';
      } else {
        return this.lang = 'en';
      }
  },
  mounted() {
    this.langLinks = window.vue_altlang_href;
    if (this.langLinks !== null) {
      console.log(window.vue_altlang_href)
    } else {
      console.log('problem with vue_altlang_href')
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";

.landing-component {
  overflow: hidden;
  position: relative;
  margin-bottom: 50px;
  .header {
    position: absolute;
    top: 0;
    left: 0;
    height: 90px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 100px;
    padding-left: 40px;
    .back {
      z-index: 3;
      background: white;
      border-radius: 7px;
      border: none;
      height: fit-content;
      cursor: pointer;
      h3 {
        font-size: 20px;
        color: black;
        line-height: 20px;
        margin: 5px;
        text-transform: uppercase;
        a {
          color: black;
          text-decoration: none;
        }
      }
      &:hover {
        h3 {
          color: #353535;
        }
      }
    }
    .lang-switch {
      z-index: 3;
      font-size: 20px;
      line-height: 20px;
      color: white;
      margin: 0;
      text-shadow: 1px 1px 10px rgba(0, 0, 0, 0.8);
      &.it {
        a.it{
          text-decoration: underline;
        }
      }
      &.en {
        a.en{
          text-decoration: underline;
        }
      }
      a {
        color: white;
        text-decoration: none;
      }
    }
    .social-share {
      position: absolute;
      top: 30px;
      right: 40px;
      background: white;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      z-index: 3;
      cursor: pointer;
      .share-icon {
        position: absolute;
        top: 6px;
        left: 6px;
      }
      .social-icons {
        position: absolute;
        top: 35px;
        left: 3px;
        text-shadow: 1px 1px 20px rgba(0, 0, 0, 0.5);
      }
    }
  }
  .landing-image {
    background: grey;
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 100%;
    transform: scale(1.4);
    transition: all 2.5s ease;
    &.active {
      background-position: 70% 100%;
      transform: scale(1);
    }
  }
  .title {
    width: 80%;
    margin-bottom: 50px;
    position: absolute;
    bottom: 30px;
    left: 10%;
    display:flex;
    align-items: center;
    justify-content: center;
  }
}
@media (max-width: 768px) {
  .landing-component {
    padding: 0;
    margin-bottom: 0px;
    overflow: visible;
    .header {
      padding: 15px 25px;
      flex-direction: column;
      align-items: flex-start;
      .back h3 {
        font-size: 15px;
      }
      .lang-switch {
        margin-left: 10px;
        a {
          font-size: 15px;
        }
      }
       .social-share {
         top: 18px;
         right: 25px;
       }
    }
   
    .landing-image {
      height: 180px;
      transform: scale(1);
    }
    .title {
      position: relative;
      width: 100%;
      padding: 0 15px;
      margin-top: 50px;
      margin-bottom: 0;
      left: 0;
      h1 {
        color: black;
        font-size: 30px;
        line-height: 40px;
        text-shadow: none;
      }
      h1 {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
